import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "content-body login-customer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyledResetPassword = _resolveComponent("StyledResetPassword")!

  return (_openBlock(), _createBlock(_component_StyledResetPassword, { class: "main-warpper" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}